module.exports = __webpack_public_path__ + "img/H2.2316c1be.png";